import getApi from '../../../api/apisauceConfig'
import { ServerSentNotification } from '../../../model/Notification'
import { ServerSentNotificationMutationPayload } from './notification.model'

export const putNotification = (id: string, notification: ServerSentNotificationMutationPayload) =>
  getApi().put<ServerSentNotification>(`admin/notifications/${id}`, notification)
